import {KEY_POINT_TOKENS, SPECIAL_BUILDING_TOKENS} from "./tokens";

export const INCOME_TYPE = {
  COINS: 'coins',
  WIN_POINTS: 'winPoints',
}

export const INCOME_TYPE_MAPPING = {
  [KEY_POINT_TOKENS.MINE]: INCOME_TYPE.COINS,
  [KEY_POINT_TOKENS.SUPER_MINE]: INCOME_TYPE.COINS,
  [KEY_POINT_TOKENS.RUINS]: INCOME_TYPE.WIN_POINTS,
  [KEY_POINT_TOKENS.SUPER_RUINS]: INCOME_TYPE.WIN_POINTS,
  [SPECIAL_BUILDING_TOKENS.GUILD]: INCOME_TYPE.COINS,
  [SPECIAL_BUILDING_TOKENS.TEMPLE]: INCOME_TYPE.WIN_POINTS
}